import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { ProjectRelatedVersionsService } from '@core/services/project-related-versions/project-related-versions.service';
import { ProjectRVErrors, ProjectRVStarting } from '@core/store/state/project-related-versions/project-related-versions.state';
import * as Objects from '@core/objects';

import { VersionShareItem } from '@core/models/version-share.model';


@Component({
    selector: 'core-versions-related-files-list-checkbox',
    templateUrl: './versions-related-files-list-checkbox.component.html',
    styleUrls: ['./versions-related-files-list-checkbox.component.scss']
})
export class VersionsRelatedFilesListCheckboxComponent implements OnInit, OnDestroy {

    public readonly LOADING = 0;
    public readonly DONE = 1;
    public readonly ERROR = 2;

    @Input() related: Objects.RelatedVersions;
    @Input() disabled: boolean;
    @Input() selected: Array<Objects.File>;
    @Output() selectedChange = new EventEmitter<Array<Objects.File>>();

    public status: number = this.LOADING;
    public starting: ProjectRVStarting;
    public versions: Array<Objects.Version> = [];
    public feedbacks: Array<VersionShareItem>;
    
    private subs: Subscription = new Subscription();


    constructor(private projectRVSrv: ProjectRelatedVersionsService) { }

    ngOnInit() {
        this.subs.add(
            this.projectRVSrv.selectStarting().subscribe((ready_situation: ProjectRVStarting) => {
                this.starting = ready_situation;
                this.init();
            })
        );

    }

    ngOnDestroy(): void {
        this.subs.unsubscribe();
    }

    private init() {
        if (this.starting && this.related && this.related.versions) {
            this.versions = this.related.versions;
            this.loadFeedbacks(this.versions);
            this.status = this.DONE;
        }
    }

    onChange(files: Array<Objects.File>) {
        this.selected = files;
        this.selectedChange.emit(this.selected);
    }

    loadFeedbacks(versions: Array<Objects.Version>) : void  {
        this.subs.add(
            this.projectRVSrv.selectFeedbacksForVersions(versions).subscribe((feedbacks: VersionShareItem[]) => {
                this.feedbacks = feedbacks;
            })
        );
    }

    public getFeedbacks(version: Objects.Version) {
        return this.feedbacks != null ? this.feedbacks.filter((f: VersionShareItem) => f.version.id == version.id) : null;
    }


}
